import { AuthRepository } from '@/domain/repositories/auth/AuthRepository'

export class LogoutUseCase {
  constructor(private authRepository: AuthRepository) {}

  async logout(): Promise<void> {
    try {
      await this.authRepository.logout()
    } catch (error) {
      console.error(`Error in LogoutUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
